import React, { useState } from "react";
import Icon from "components/AppIcon";

const formatRevenue = (v) => {
  if (v >= 10000000) return `₹${(v / 10000000)?.toFixed(1)}Cr`;
  if (v >= 100000) return `₹${(v / 100000)?.toFixed(1)}L`;
  return `₹${v?.toLocaleString('en-IN')}`;
};

export default function TopRegionsTable({ regions: regionsProp }) {
  const [hoveredRow, setHoveredRow] = useState(null);
  const rows = regionsProp || [];

  return (
    <div
      className="card-base flex flex-col gap-3 min-w-0"
      style={{ background: "var(--color-card)", borderRadius: "var(--radius-md)" }}
    >
      <div className="flex items-center justify-between gap-2">
        <h3 className="font-heading font-semibold text-sm md:text-base" style={{ color: "var(--color-foreground)" }}>
          Top Revenue Regions
        </h3>
        <Icon name="MapPin" size={16} color="var(--color-text-secondary)" />
      </div>
      <div className="table-container">
        <table className="w-full" style={{ borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid var(--color-border)" }}>
              {["#", "Region", "Revenue", "Growth", "Share"]?.map((h) => (
                <th
                  key={h}
                  className="pb-2 font-caption text-xs font-semibold uppercase tracking-wide text-left"
                  style={{ color: "var(--color-text-secondary)", paddingRight: h !== "Share" ? "12px" : "0" }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows?.map((r) => {
              const isHovered = hoveredRow === r?.rank;
              const growthColor = r?.growth >= 15 ? "var(--color-success)" : r?.growth >= 8 ? "var(--color-warning)" : "var(--color-error)";
              return (
                <tr
                  key={r?.rank}
                  className="cursor-pointer transition-all duration-150"
                  style={{
                    borderBottom: "1px solid var(--color-border)",
                    background: isHovered ? "var(--color-muted)" : "transparent",
                  }}
                  onMouseEnter={() => setHoveredRow(r?.rank)}
                  onMouseLeave={() => setHoveredRow(null)}
                >
                  <td className="py-2.5 pr-3">
                    <span
                      className="font-data text-xs font-bold flex items-center justify-center rounded-full"
                      style={{
                        width: "20px",
                        height: "20px",
                        background: r?.rank === 1 ? "var(--color-accent)" : "var(--color-muted)",
                        color: r?.rank === 1 ? "var(--color-accent-foreground)" : "var(--color-text-secondary)",
                      }}
                    >
                      {r?.rank}
                    </span>
                  </td>
                  <td className="py-2.5 pr-3">
                    <span className="font-caption text-sm font-medium" style={{ color: "var(--color-foreground)" }}>
                      {r?.region}
                    </span>
                  </td>
                  <td className="py-2.5 pr-3 whitespace-nowrap">
                    <span className="font-data text-sm font-semibold" style={{ color: "var(--color-foreground)" }}>
                      {formatRevenue(r?.revenue)}
                    </span>
                  </td>
                  <td className="py-2.5 pr-3 whitespace-nowrap">
                    {r?.growth !== null && r?.growth !== undefined ? (
                      <div className="flex items-center gap-1">
                        <Icon
                          name={r?.growth >= 0 ? "TrendingUp" : "TrendingDown"}
                          size={12}
                          color={growthColor}
                          strokeWidth={2.5}
                        />
                        <span className="font-data text-xs font-semibold" style={{ color: growthColor }}>
                          +{r?.growth}%
                        </span>
                      </div>
                    ) : (
                      <span className="font-caption text-xs" style={{ color: "var(--color-text-secondary)" }}>—</span>
                    )}
                  </td>
                  <td className="py-2.5">
                    <div className="flex items-center gap-2">
                      <div
                        className="rounded-full overflow-hidden"
                        style={{ width: "48px", height: "6px", background: "var(--color-muted)" }}
                      >
                        <div
                          className="h-full rounded-full"
                          style={{ width: `${r?.share}%`, background: "var(--color-primary)" }}
                        />
                      </div>
                      <span className="font-data text-xs" style={{ color: "var(--color-text-secondary)" }}>
                        {r?.share}%
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })}
            {rows?.length === 0 && (
              <tr>
                <td colSpan={5} className="py-10 text-center">
                  <span className="font-caption text-sm" style={{ color: "var(--color-text-secondary)" }}>
                    No region data yet — deals closed will appear here
                  </span>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}